
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 399","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M483 .5H37.2c-13.6 0-26 12.4-26 26v309.6c0 14.9 12.4 26 26 26H172.1v17.3c0 3.7 2.5 6.2 6.2 6.2h14.9c3.7 0 6.2-2.5 6.2-6.2v-17.3h121.3v17.3c0 3.7 2.5 6.2 6.2 6.2h14.9c3.7 0 6.2-2.5 6.2-6.2v-17.3h135c14.9 0 26-12.4 26-26V26.5c0-13.6-11.2-26-26-26zM73.1 334.8H38.4v-307h34.7zm112.7-49.5c-19.8 0-35.9-16.1-35.9-35.9s16.1-35.9 35.9-35.9 35.9 16.1 35.9 35.9-16.1 35.9-35.9 35.9zm-35.9-172.1c0-19.8 16.1-35.9 35.9-35.9s35.9 16.1 35.9 35.9-16.1 35.9-35.9 35.9-35.9-16.1-35.9-35.9zm170.9 221.6H199.4v-23.5c23.5-5 42.1-23.5 48.3-48.3h24.8c5 23.5 23.5 42.1 48.3 48.3zm13.6-49.5c-19.8 0-35.9-16.1-35.9-35.9s16.1-35.9 35.9-35.9 35.9 16.1 35.9 35.9-16.1 35.9-35.9 35.9zm-35.9-172.1c0-19.8 16.1-35.9 35.9-35.9s35.9 16.1 35.9 35.9-16.1 35.9-35.9 35.9-35.9-16.1-35.9-35.9zm121.3 221.6H348v-23.5c28.5-6.2 49.5-32.2 49.5-61.9s-21-55.7-49.5-61.9v-12.4c28.5-6.2 49.5-32.2 49.5-61.9 0-34.7-27.2-63.2-63.2-63.2-35.9 0-63.2 28.5-63.2 63.2 0 29.7 21 55.7 49.5 61.9v12.4c-23.5 5-42.1 23.5-48.3 48.3h-24.8c-5-23.5-23.5-42.1-48.3-48.3v-12.4c28.5-6.2 49.5-32.2 49.5-61.9 0-34.7-27.2-63.2-63.2-63.2-35.9 0-63.2 28.5-63.2 63.2 0 29.7 21 55.7 49.5 61.9v12.4c-28.5 6.2-49.5 32.2-49.5 61.9s21 55.7 49.5 61.9v23.5H100v-307h319.5v307zm61.9 0H447v-307h34.7z"}})])
          )
        }
      }
    